import { CircularProgress } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import LinkedInService from '../../services/LinkedInService'
import { AuthenticatedUserData, LinkedInLoginResponse } from '../../models/auth'
import { AppRoutes } from '../../helpers/routes'
import { useNavigate } from 'react-router-dom'
import useSignIn from 'react-auth-kit/hooks/useSignIn'
import { useSnackbar } from 'notistack'
import CustomPaper from '../../containers/Paper'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import CustomButton from '../../components/Button'

const ActivateLikedinUserPage = () => {
    const navigate = useNavigate()
    const signIn = useSignIn()
    const [loading, setLoading] = useState<boolean>(true)
    const { enqueueSnackbar } = useSnackbar()

    const handleLogin = useCallback(
        async (code: any) => {
            if (!loading) return
            const response = await new LinkedInService().loginWithLinkedIn(code)
            if (response.status === 200) {
                const data = response.data as LinkedInLoginResponse
                if (data.isNewUser) {
                    navigate(AppRoutes.register, {
                        state: { linkedInUser: data.userResponseDTO },
                    })
                    localStorage.setItem('linkedinToken', data.loginResponseDTO.token)
                } else if (data.loginResponseDTO.approved) {
                    signIn({
                        auth: { token: data.loginResponseDTO.token, type: 'Bearer' },
                        userState: {
                            picture: data.loginResponseDTO.picture,
                            fullName: data.loginResponseDTO.fullName,
                        } as AuthenticatedUserData,
                    })
                    navigate(AppRoutes.home)
                } else setLoading(false)
            } else {
                enqueueSnackbar('Error inesperado', {
                    variant: 'error',
                    autoHideDuration: 6000,
                })
                navigate(AppRoutes.login)
            }
        },
        [navigate, signIn, enqueueSnackbar, loading],
    )

    const handleLinkedInCallback = useCallback(() => {
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        const code = urlParams.get('code')
        const error = urlParams.get('error')
        if (code) {
            handleLogin(code)
        } else if (error) {
            navigate(AppRoutes.login)
        }
    }, [handleLogin])

    useEffect(() => {
        handleLinkedInCallback()
    }, [handleLinkedInCallback])

    return (
        <div className="flex flex-col justify-center items-center w-full h-full gap-8 md:gap-16">
            {loading ? (
                <>
                    <span className="w-full text-center text-2xl">
                        Sincronizando con LinkedIn...
                    </span>
                    <CircularProgress size={128} />
                </>
            ) : (
                <CustomPaper className="w-[70vw] md:w-[35vw] p-3 md:p-6 text-primary flex flex-col gap-3 md:gap-8">
                    <span className="w-full text-center text-xl md:text-4xl font-bold">
                        Usuario pendiente de aprobación
                    </span>
                    <div className="flex gap-2 md:gap-6 mx-2 items-center justify-center">
                        <div className="flex gap-2 md:gap-6 flex-col">
                            <span className="text-base md:text-2xl font-semibold">
                                El usuario se creó correctamente y ahora necesita ser aprobado por
                                un administrador.
                            </span>
                            <span className="text-sm md:text-xl">
                                Se te informará por correo cuando esto suceda.
                            </span>
                        </div>
                        <VerifiedUserIcon className="text-[75px] md:text-[200px] text-alert" />
                    </div>
                    <CustomButton
                        text="Volver al inicio"
                        onClick={() => navigate(AppRoutes.login)}
                    />
                </CustomPaper>
            )}
        </div>
    )
}

export default ActivateLikedinUserPage
